/* eslint-disable */
// @flow

import Avatar from '@atlaskit/avatar';
import Button from '@atlaskit/button/standard-button';
import { FieldTextStateless } from '@atlaskit/field-text';
import InlineDialog from '@atlaskit/inline-dialog';
import Spinner from '@atlaskit/spinner';
import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';

import { Dialog, openDialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import {
    Icon,
    IconDropBox,
    IconFacebook,
    IconInstagram,
    IconYoutube,
    IconLinkedin,
    IconVimeo,
    IconPlusCircle,
    IconCustom,
    IconTwitch,
    IconAws,
    IconRec
} from '../../../../base/icons';
import { Switch } from '../../../../base/react';
import { connect } from '../../../../base/redux';
import GetMediaQuery from '../../../../base/util/GetMediaQuery';
import {
    GOOGLE_API_STATES,
    GoogleSignInButton,
    loadGoogleAPI,
    requestAvailableYouTubeBroadcasts,
    requestLiveStreamsForYouTubeBroadcast,
    showAccountSelection,
    signIn,
    updateProfile
} from '../../../../google-api';
import StartRecordingDialogContent from '../../Recording/StartRecordingDialogContent';
import StartRecordingDialogs from '../../Recording/StartRecordingDialogs';
import AbstractStartLiveStreamDialog, {
    _mapStateToProps as _abstractMapStateToProps,
    type Props as AbstractProps
} from '../AbstractStartLiveStreamDialog';

import StreamKeyForm from './StreamKeyForm';
import StreamKeyPicker from './StreamKeyPicker';


const YOUTUBE = 'http://pngimg.com/uploads/youtube/youtube_PNG102349.png';
const FACEBOOK = 'http://pngimg.com/uploads/facebook_logos/facebook_logos_PNG19753.png';
const TWITCH = 'http://pngimg.com/uploads/twitch/twitch_PNG56.png';
const LINKEDIN = 'http://pngimg.com/uploads/linkedIn/linkedIn_PNG32.png';
const DropBox = 'images/dropbox.png';
const CUSTOMRTMP = 'images/radio.png';
const INSTAGRAM = 'http://pngimg.com/uploads/instagram/instagram_PNG9.png';
const VIMEO = 'images/vimeo.png';
const RECORDING = 'images/record.png';
const AWS_LOGO = 'images/logo.png';


type Props = AbstractProps & {


    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    /**
     * The ID for the Google client application used for making stream key
     * related requests.
     */
    _googleApiApplicationClientID: string,
}

/**
 * A React Component for requesting a YouTube stream key to use for live
 * streaming of the current conference.
 *
 * @extends Component
 */
class StartLiveStreamDialog
    extends AbstractStartLiveStreamDialog<Props> {

    /**
     * Initializes a new {@code StartLiveStreamDialog} instance.
     *
     * @param {Props} props - The React {@code Component} props to initialize
     * the new {@code StartLiveStreamDialog} instance with.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onGetYouTubeBroadcasts = this._onGetYouTubeBroadcasts.bind(this);
        this._onInitializeGoogleApi = this._onInitializeGoogleApi.bind(this);
        this._onGoogleSignIn = this._onGoogleSignIn.bind(this);
        this._onRequestGoogleSignIn = this._onRequestGoogleSignIn.bind(this);
        this._onYouTubeBroadcastIDSelected
            = this._onYouTubeBroadcastIDSelected.bind(this);
        this._onToggleStream = this._onToggleStream.bind(this);

    }

    /**
     * Implements {@link Component#componentDidMount()}. Invoked immediately
     * after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();

        // if (this.props._googleApiApplicationClientID) {
        //     this._onInitializeGoogleApi();
        // }
    }


    /**
     * Toggles the  Dialog.
     *
     * @returns {void}
     */
    toggleDialog = () => this.setState({ dialogOpen: !this.state.dialogOpen });

    /**
     * Content Created from the Data in the Interface Config.js.
     *
     * @returns {React#Element}
     */
    content = () => {
        const { liveStreamTools, recTools } = this.state;
        const storageType = this.state.recTypeData?.storage;
        return (
            <>
                                <div>
                {

                    recTools ? recTools.map((item, i) => (
                        <div
                            className = 'rows'
                            key = { i }
                            style = {{ 'width': '350px' }} >
                            <div className = 'col-m-10'>
                                <label
                                    className = 'file-upload-label12'
                                    htmlFor = 'file-upload' >
                                    <Icon
                                        className = { 'add-background' }
                                        size = { 20 }
                                        src = { item.icon === 'IconFacebook' ? IconFacebook : item.icon === 'IconYoutube' ? IconYoutube : item.icon === 'IconTwitch' ? IconTwitch : item.icon === 'IconLinkedin' ? IconLinkedin : item.icon === 'IconInstagram' ? IconInstagram : item.icon === 'IconCustom' ? IconCustom : this.state.isAws ? IconRec : IconDropBox } />
                                    {this.state.isAws ? storageType === 'Local' ?  'Meet Hour Recording' : 'Custom Aws Recording' : item.title}

                                </label>
                            </div>
                            <div className = 'col-m-2' >
                                <Switch
                                    onValueChange = { () => {
                                        this._onToggleStream(item.title, item.toggle,true);
                                        this.setState({ recordingO: !this.state.recordingO });
                                    } }
                                    value = { this.state.streamEnabledWeb.some(itm => itm?.title === item.title) || false  }
                                    disabled = { !this.state.streamEnabledWeb.some(itm => itm?.title === item.title) && this.state.streamEnabledWeb.length >= 3 } />
                            </div>

                        </div>
                    )) : ''
                }

                <div className = 'invite-more-dialog separator' />

                {
                    liveStreamTools ? liveStreamTools.map((item, i) => {

                        if (item.enabled) {
                            return (
                                <div
                                    className = 'rows'
                                    key = { i }
                                    style = {{ 'width': '350px' }} >
                                    <div className = 'col-m-10'>
                                        <label
                                            className = 'file-upload-label12'
                                            htmlFor = 'file-upload'>
                                            <Icon
                                                className = { 'add-background' }
                                                size = { 20 }
                                                src = { item.icon === 'IconFacebook' ? IconFacebook : item.icon === 'IconYoutube' ? IconYoutube : item.icon === 'IconTwitch' ? IconTwitch : item.icon === 'IconLinkedin' ? IconLinkedin : item.icon === 'IconInstagram' ? IconInstagram : item.icon === 'IconCustom' ? IconCustom : (item.icon === 'IconVimeo' ? IconVimeo : IconCustom) } />
                                            {item.title}


                                        </label>
                                    </div>
                                    <div className = 'col-m-2' >
                                        <Switch
                                            onValueChange = { () => this._onToggleStream(item.title, item.toggle) }
                                            value = { this.state.streamEnabledWeb.some(itm => itm?.title === item?.title) || false }
                                            disabled = { !this.state.streamEnabledWeb.some(itm => itm?.title === item?.title) && this.state.streamEnabledWeb.length >= 3 } />
                                    </div>

                                </div>
                            );
                        }

                    }) : ''
                }
                </div>
        </>
        );
    }

    /**
     * Form for Adding your Stream Key.
     * @param {string} title - Title
     *  @param {i} - index
     * @returns {React#Element}
     */
    formStreamKey = (title,i) => (
          <div
              key = { i }
              style = {{ display: 'inline-flex',    width: '448px' }}>
              <FieldTextStateless
                  autoFocus = { true }
                  compact = { true }
                  isSpellCheckEnabled = { false }
                  name = 'streamIdFB'
                  okDisabled = { false }
                  onChange = { e => {
                    //   this.setState({
                    //       streamKeys: [

                    //           [`streamKey${parseInt(i) + 1}`]: e.target.value
                    //       ]
                    //   }
                    //   );
                    this.setState(prevState => {
                        const streamsKey = prevState.streamEnabledWeb.some(it => it?.title === title)
                        if(streamsKey){
                            return {
                                ...prevState,
                                streamEnabledWeb:  prevState.streamEnabledWeb.map(prv => {
                                    if(prv?.title === title){
                                        prv.value = e.target.value
                                    }

                                    return prv
                                })
                               }
                        }
                       return {
                        ...prevState,
                        streamEnabledWeb:  prevState.streamEnabledWeb.push({
                            title,
                            value: e.target.value
                        })
                       }
                    })

                  } }
                  placeholder = { title === 'LinkedIn' ? `Enter ${title} stream Key with url` :  `Enter ${title} stream Key`}
                  shouldFitContainer = { true }
                  type = 'text'
                  value = { this.state?.streamEnabledWeb.find(it => it?.title === title)?.value ?? undefined } />
              <div
                  style = {{ paddingTop: '24px',
                      paddingLeft: '12px' }}>
                  <Button
                      onClick = { () =>                     this.setState(prevState => ({
                        streamEnabledWeb: prevState.streamEnabledWeb?.some(it => it?.title === title && it.hasOwnProperty('open')) ?  prevState.streamEnabledWeb.map(it => {
                            if(it.title === title){
                                it.open = !it.open
                            }
                            return it
                        }) : prevState.streamEnabledWeb
                    })) }
                      appearance = 'primary'>
            Save

                  </Button>
              </div>
          </div>
      )

    /**
     * Adding a Recording Dialog.
     *
     * @returns {React#Element}
     */
    addRecordString = () => {
          const {
              isTokenValid,
              isValidating,
              selectedRecordingService,
              sharingEnabled,
              spaceLeft,
              userName,
              recTypeData,
              isAws
          } = this.state;
          const { t } = this.props;
          const { _fileRecordingsServiceEnabled, _fileRecordingsServiceSharingEnabled, _isDropboxEnabled, _googleApiApplicationClientID } = this.props;
          const storageType = this.state.recTypeData?.storage;
          const { s3_free_space = null, s3_used_space = null } = this.state?.recTypeData ?? {};

          return (
              <div style = {{ width: '320px' }}>
                            <StartRecordingDialogContent
                                fileRecordingsServiceEnabled = { _fileRecordingsServiceEnabled }
                                fileRecordingsServiceSharingEnabled = { _fileRecordingsServiceSharingEnabled }
                                integrationsEnabled = { this._areIntegrationsEnabled() }
                                isAws = { isAws }
                                isTokenValid = { isTokenValid }
                                isValidating = { isValidating }
                                onChange = { this._onSelectedRecordingServiceChanged }
                                onSharingSettingChanged = { this._onSharingSettingChanged }
                                selectedRecordingService = { selectedRecordingService }
                                sharingSetting = { sharingEnabled }
                                spaceLeft = { spaceLeft }
                                storageSpace = {{ s3_free_space,
                                    s3_used_space }}
                                storageType = { storageType }
                                userName = { userName } />
              </div>
          );
      }

      /**
     * Implements {@code Component}'s render.
     *
     * @inheritdoc
     */
      render() {

          const { t } = this.props;
          const { _googleApiApplicationClientID } = this.props;
          return (
            <>
              <Dialog
                  cancelKey = 'dialog.Cancel'
                  disableOverlay = { true }
                  okKey = {this.state.streamEnabledWeb.every(it => it?.isRec !== true) ? 'Live Stream' :'dialog.startLiveStreaming'}
                  onCancel = { this._onCancel }
                  onSubmit = { this._onSubmit }
                  submitDisabled = { this._onDisable(true) }
                  titleKey = 'liveStreaming.start'
                  width = { '400px' }>
                    <div className = 'help-tip'>
                <p> {t('liveStreaming.note')}: <br />
     1.{t('liveStreaming.enterLinkedInUrlWithTheKey')}<br />
     </p>
            </div>
                  <div className = 'live-stream-dialog'>
                      { _googleApiApplicationClientID
                          ? this._renderYouTubePanel() : null }
                      <div
                          id = 'live-stream-section'
                          style = {{ display: 'flex' }}>
                          <div style = {{ width:'213px'}}>
                              <InlineDialog
                                  onClose = { () => {
                                      this.setState({ dialogOpen: false });
                                  } }
                                  content = { this.content() }
                                  isOpen = { this.state.dialogOpen }
                                  placement = 'right-start'>
                                  <label
                                      className = 'file-upload-label1'
                                      htmlFor = 'file-upload'
                                      onClick = { this.toggleDialog }>
                                      <Icon
                                          className = { 'add-background' }
                                          size = { 20 }
                                          src = { IconPlusCircle } />
                        { t('liveStreaming.addStream')}
                                  </label>
                              </InlineDialog>
                          </div>
                          <div className = 'rows'>
                              {

Array.isArray(this.state.streamEnabledWeb) && this.state.streamEnabledWeb?.length > 0 &&    this.state.streamEnabledWeb
.map((item, i) => {
    const dev1 = `openDialog${item?.title}`;

    return (
        <div
            className = 'col-m-4'
            style = {{ 'textAlign': 'center' }}
            key = { i }>
            <InlineDialog
                onClose = { () => {
                    this.setState(prevState => ({
                        streamEnabledWeb: prevState.streamEnabledWeb?.some(it => it?.title === item?.title && item.open === true) ?  prevState.streamEnabledWeb.map(it => {
                            if(it.title === item.title){
                                it.open = !it.open
                            }
                            return it
                        }) : prevState.streamEnabledWeb
                    }))
                } }
                content = { item?.title  === 'DropBox Recording' ? this.addRecordString() : this.formStreamKey(item.title,i) }
                isOpen = { item.open ?? false }
                placement = 'bottom'>
                <Avatar
                    appearance = 'circle'
                    src = { item.title === 'Youtube' ? YOUTUBE : item.title  === 'Facebook' ? FACEBOOK : item.title  === 'Twitch' ? TWITCH : item.title  === 'LinkedIn' ? LINKEDIN : item.title  === 'Custom RTMP' ? CUSTOMRTMP : item.title  === 'Instagram' ? INSTAGRAM : (item.title  === 'Custom RTMPS' ? CUSTOMRTMP : (item.title  === 'Vimeo' ? VIMEO : this.state.isAws ? AWS_LOGO : RECORDING ))}
                    onClick = { () => {
                        this.setState(prevState => {

                            return {
                            streamEnabledWeb: prevState.streamEnabledWeb?.some(it => it?.title === item?.title && it.hasOwnProperty('open')) ?  prevState.streamEnabledWeb.map(it => {
                                if(it.title === item.title){
                                    it.open = !it.open
                                }
                                return it
                            }) : prevState.streamEnabledWeb
                        }
                    })
                    } }
                    presence = { (typeof item.value === 'string' && !isEmpty(item.value) ) || ((item.title === 'DropBox Recording') && (this.props._token || this.state.isAws)) ? 'online' : 'focus' }
                    size = 'large' />
            </InlineDialog>

        </div>
    );
}

)
 }
                          </div>
                      </div>

                  </div>
              </Dialog>
              </>
          );
      }


    _areIntegrationsEnabled: () => boolean;
    _onSelectedRecordingServiceChanged: (string) => void;
    _onSharingSettingChanged: () => void;

    _onToggleStream: (title:string, toggle:boolean, isRec: boolean) => void;

    /**
     * Callback to be invoked when the user toggles the stream feature on or off.
     * @param {title} - Title of the Parameter
     * @param - {toggle} - Toggle Boolean
     * @returns {void}
     */
    _onToggleStream(title, toggle, isRec = false) {
        const titl = title;
        const toggl = toggle;

       const checkIfKeyExisted =  this.state.streamEnabledWeb.some((itm) =>  itm.title === title)
       if(checkIfKeyExisted){
            this.setState({
                streamEnabledWeb: this.state.streamEnabledWeb.filter(itm => itm.title !== title)
            },() => console.log('this.state',this.state))

            return;
       }


       const pushKey =   this.state.streamEnabledWeb
       pushKey.push({ title, toggle: typeof toggle === 'boolean' ? !toggle : true, open: false, value: undefined, isRec })
       this.setState({
        streamEnabledWeb: pushKey
    },() => console.log('this.state',this.state))


    

        // if (Object.keys(this.state.streamEnabledWeb).length === 0) {
        //     const states = this.state
        //     states['streamEnabledWeb'][`${titl}`] = !toggl;
        //     states['streamsEnabled'][`${titl}`] = titl;
        //     this.setState(states,() => { 
        //     });

        // } else {
        //     const states = this.state
        //     if (states['streamEnabledWeb'][`${titl}`]) {
        //         delete states['streamEnabledWeb'][`${titl}`];
        //         delete states['streamsEnabled'][`${titl}`];
        //     } else {
        //         states['streamEnabledWeb'][`${titl}`] = !states['streamEnabledWeb'][`${titl}`];
        //         states['streamsEnabled'][`${titl}`] = titl;
        //     }

        //     this.setState(states);
        // }

    }


    _onCancel: () => boolean;

    _onDisable: () => Boolean;

    _onSubmit: () => boolean;

    _onInitializeGoogleApi: () => void;

    /**
     * Loads the Google web client application used for fetching stream keys.
     * If the user is already logged in, then a request for available YouTube
     * broadcasts is also made.
     *
     * @private
     * @returns {void}
     */
    _onInitializeGoogleApi() {
        this.props.dispatch(loadGoogleAPI())
        .catch(response => this._parseErrorFromResponse(response));
    }

    /**
     * Automatically selects the input field's value after starting to edit the
     * display name.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidUpdate(previousProps) {
        if (previousProps._googleAPIState === GOOGLE_API_STATES.LOADED
            && this.props._googleAPIState === GOOGLE_API_STATES.SIGNED_IN) {
            this._onGetYouTubeBroadcasts();
        }
    }

    _onGetYouTubeBroadcasts: () => void;

    /**
     * Asks the user to sign in, if not already signed in, and then requests a
     * list of the user's YouTube broadcasts.
     *
     * @private
     * @returns {void}
     */
    _onGetYouTubeBroadcasts() {
        this.props.dispatch(updateProfile())
            .catch(response => this._parseErrorFromResponse(response));

        this.props.dispatch(requestAvailableYouTubeBroadcasts())
            .then(broadcasts => {
                this._setStateIfMounted({
                    broadcasts
                });

                if (broadcasts.length === 1) {
                    const broadcast = broadcasts[0];

                    this._onYouTubeBroadcastIDSelected(broadcast.boundStreamID);
                }
            })
            .catch(response => this._parseErrorFromResponse(response));
    }

    _onGoogleSignIn: () => Object;

    /**
     * Forces the Google web client application to prompt for a sign in, such as
     * when changing account, and will then fetch available YouTube broadcasts.
     *
     * @private
     * @returns {Promise}
     */
    _onGoogleSignIn() {
        this.props.dispatch(signIn())
            .catch(response => this._parseErrorFromResponse(response));
    }

    _onRequestGoogleSignIn: () => Object;

    /**
     * Forces the Google web client application to prompt for a sign in, such as
     * when changing account, and will then fetch available YouTube broadcasts.
     *
     * @private
     * @returns {Promise}
     */
    _onRequestGoogleSignIn() {
        // when there is an error we show the google sign-in button.
        // once we click it we want to clear the error from the state
        this.props.dispatch(showAccountSelection())
            .then(() =>
                this._setStateIfMounted({
                    broadcasts: undefined,
                    errorType: undefined
                }))
            .then(() => this._onGetYouTubeBroadcasts());
    }


    _onYouTubeBroadcastIDSelected: (string) => Object;

    /**
     * Fetches the stream key for a YouTube broadcast and updates the internal
     * state to display the associated stream key as being entered.
     *
     * @param {string} boundStreamID - The bound stream ID associated with the
     * broadcast from which to get the stream key.
     * @private
     * @returns {Promise}
     */
    _onYouTubeBroadcastIDSelected(boundStreamID) {
        this.props.dispatch(
            requestLiveStreamsForYouTubeBroadcast(boundStreamID))
            .then(({ streamKey, selectedBoundStreamID }) =>
                this._setStateIfMounted({
                    streamKey,
                    selectedBoundStreamID
                }));

    }

    /**
     * Only show an error if an external request was made with the Google api.
     * Do not error if the login in canceled.
     * And searches in a Google API error response for the error type.
     *
     * @param {Object} response - The Google API response that may contain an
     * error.
     * @private
     * @returns {string|null}
     */
    _parseErrorFromResponse(response) {

        if (!response || !response.result) {
            return;
        }

        const result = response.result;
        const error = result.error;
        const errors = error && error.errors;
        const firstError = errors && errors[0];

        this._setStateIfMounted({
            errorType: (firstError && firstError.reason) || null
        });
    }

    /**
     * Renders a React Element for authenticating with the Google web client.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderYouTubePanel() {
        const {
            t,
            _googleProfileEmail
        } = this.props;
        const {
            broadcasts,
            selectedBoundStreamID
        } = this.state;

        let googleContent, helpText;

        switch (this.props._googleAPIState) {
        case GOOGLE_API_STATES.LOADED:
            googleContent
                = <GoogleSignInButton onClick = { this._onGoogleSignIn } />;
            helpText = t('liveStreaming.signInCTA');

            break;

        case GOOGLE_API_STATES.SIGNED_IN:
            if (broadcasts) {
                googleContent = (
                    <StreamKeyPicker
                        broadcasts = { broadcasts }
                        onBroadcastSelected
                            = { this._onYouTubeBroadcastIDSelected }
                        selectedBoundStreamID = { selectedBoundStreamID } />
                );
            } else {
                googleContent = (
                    <Spinner
                        isCompleting = { false }
                        size = 'medium' />
                );
            }

            /**
             * FIXME: Ideally this help text would be one translation string
             * that also accepts the anchor. This can be done using the Trans
             * component of react-i18next but I couldn't get it working...
             */
            helpText = (
                <div>
                    { `${t('liveStreaming.chooseCTA',
                        { email: _googleProfileEmail })} ` }
                    <a onClick = { this._onRequestGoogleSignIn }>
                        { t('liveStreaming.changeSignIn') }
                    </a>
                </div>
            );

            break;

        case GOOGLE_API_STATES.NEEDS_LOADING:
        default:
            googleContent = (
                <Spinner
                    isCompleting = { false }
                    size = 'medium' />
            );

            break;
        }

        if (this.state.errorType !== undefined) {
            googleContent = (
                <GoogleSignInButton
                    onClick = { this._onRequestGoogleSignIn } />
            );
            helpText = this._getGoogleErrorMessageToDisplay();
        }

        return (
            <div className = 'google-panel'>
                <div className = 'live-stream-cta'>
                    { helpText }
                </div>
                <div className = 'google-api'>
                    { googleContent }
                </div>
            </div>
        );
    }

    _setStateIfMounted: Object => void

    /**
     * Returns the error message to display for the current error state.
     *
     * @private
     * @returns {string} The error message to display.
     */
    _getGoogleErrorMessageToDisplay() {
        let text;

        switch (this.state.errorType) {
        case 'liveStreamingNotEnabled':
            text = this.props.t(
                'liveStreaming.errorLiveStreamNotEnabled',
                { email: this.props._googleProfileEmail });
            break;
        default:
            text = this.props.t('liveStreaming.errorAPI');
            break;
        }

        return <div className = 'google-error'>{ text }</div>;
    }
}

/**
 * Maps part of the Redux state to the component's props.
 *
 * @param {Object} state - The Redux state.
 * @returns {{
 *     _googleApiApplicationClientID: string
 * }}
*/
function _mapStateToProps(state: Object) {
    return {
        ..._abstractMapStateToProps(state),
        _googleApiApplicationClientID:
        state['features/base/config'].googleApiApplicationClientID
    };
}

export default translate(connect(_mapStateToProps)(StartLiveStreamDialog));
